import React from 'react'
import ReactPlaceholder from 'react-placeholder'
import { useRouteMatch, useHistory } from "react-router"
import { useSelector } from 'react-redux'
import Utils from "../../services/Utils"
import { Auth } from '../../services/Auth'
import { HeaderTopPlaceholder } from '../../components/placeholders/HeaderPlaceholders'
import { useWindowSize } from '../../routes/widget-editor/helpers/WindowSize'
import Logo from '../base/Logo'
import Language from '../base/Language'


const AuthHeader = ({ page }) => {

    const history = useHistory();
    const route = useRouteMatch();
    // const [landscape ] = useState(Browser.isLandscape());
    const { playerData = {} } = useSelector(state => state.user);
    const { isLoading: isTranslationLoading = true } = useSelector(state => state.translations);
    const isLoggedIn = Auth.isAuthenticated();
    const isHeaderLoading = !(isLoggedIn && !Object.keys(playerData.accountBalance || {})) && !isTranslationLoading
    const size = useWindowSize();


    return (
        <ReactPlaceholder customPlaceholder={<HeaderTopPlaceholder />} ready={isHeaderLoading}>
            <header className={`popup-to-page__header tb--flex tb--justify-between tb--align-center tb--w_100 ${true ? 'dhol' : ''}`}>
                <div className="tb--left-side" onClick={() => history.push('')}>
                    <Logo popupLogo={true} hideColorModeSwitch={true} />
                </div>

                <div className="tb--right-side">
                    <Language languageControl={{ isVisible: true, properties: { type: "Flag_NoName_Flag_Name" } }} />
                </div>
            </header>
        </ReactPlaceholder>
    )
}

export default AuthHeader
